import {humanJoin, parseMoment} from '@utils'
import Model from './Model'

export default class RemoteInvite extends Model {
    isViewed() {
        return this.viewed === true;
    }

    isRevoked() {
        return this.revoked === true;
    }

    get emailed_at_moment() {
        return parseMoment(this.emailed_at)
    }

    get status_summary() {
        return humanJoin([
            ...(this.viewed ? ['viewed'] : []),
            ...(this.revoked ? ['revoked'] : []),
        ])
    }

    static async all(type, identifier) {
        const params = {type, identifier}
        const {data} = await Http.get(route('api.v1.remote.index'), {params})
        return this.make(data)
    }

    static async allWithActivity(filters) {
        const params = {from: filters.from, to: filters.to, type: filters.type}

        if (_.isObject(filters.estimator) && _.isNumber(filters.estimator.value)) {
            params.estimator = filters.estimator.value
        }

        const {data} = await Http.get(route('api.v1.remote.reporting'), {params})
        return this.make(data)
    }

    // Returns an array of all RemoteInvites for that type and identifier.
    static async create(form) {
        const {data} = await Http.post(route('api.v1.remote.create'), form)
        return this.make(data)
    }

    async resend() {
        const {data} = await Http.delete(this._links.resend)
        this.fill(data)
    }

    async revoke() {
        const {data} = await Http.delete(this._links.revoke)
        this.fill(data)
    }

    async unrevoke() {
        const {data} = await Http.post(this._links.unrevoke)
        this.fill(data)
    }
}
